/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

export const REQUESTED_CONFIDENCE_SCORES = 'REQUESTED_CONFIDENCE_SCORES';
export const RECEIVED_CONFIDENCE_SCORES = 'RECEIVED_CONFIDENCE_SCORES';
export const ERROR_CONFIDENCE_SCORES = 'ERROR_CONFIDENCE_SCORES';
export const REQUESTED_MONTE_CARLO_CONFIDENCE_SCORES =
  'REQUESTED_MONTE_CARLO_CONFIDENCE_SCORES';
export const RECEIVED_MONTE_CARLO_CONFIDENCE_SCORES =
  'RECEIVED_MONTE_CARLO_CONFIDENCE_SCORES';
export const ERROR_MONTE_CARLO_CONFIDENCE_SCORES =
  'ERROR_MONTE_CARLO_CONFIDENCE_SCORES';

export const requestedConfidenceScores = () => ({
  type: REQUESTED_CONFIDENCE_SCORES
});

export const receivedConfidenceScores = (confidenceScores = []) => ({
  type: RECEIVED_CONFIDENCE_SCORES,
  confidenceScores
});

export const errorConfidenceScores = () => ({
  type: ERROR_CONFIDENCE_SCORES
});

export const requestedMonteCarloConfidenceScores = () => ({
  type: REQUESTED_MONTE_CARLO_CONFIDENCE_SCORES
});

export const receivedMonteCarloConfidenceScores = (
  monteCarloConfidenceScores = []
) => ({
  type: RECEIVED_MONTE_CARLO_CONFIDENCE_SCORES,
  monteCarloConfidenceScores
});

export const errorMonteCarloConfidenceScores = () => ({
  type: ERROR_MONTE_CARLO_CONFIDENCE_SCORES
});
